import React from 'react';
import classNames from 'classnames';

import { FormattedMessage } from '../../util/reactIntl';

import css from './PrivacyTip.module.css';

const LockIcon = () => (
  <svg className={css.icon} viewBox="0 0 24 24" width="14" height="14" aria-hidden="true">
    <rect x="5" y="11" width="14" height="10" rx="2" fill="none" stroke="currentColor" strokeWidth="1.8" />
    <path
      d="M8 11V8a4 4 0 0 1 8 0v3"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinecap="round"
    />
  </svg>
);

const ShieldIcon = () => (
  <svg className={css.icon} viewBox="0 0 24 24" width="14" height="14" aria-hidden="true">
    <path
      d="M12 3.2 20 6.2v6.1c0 4.8-3.2 8.3-8 9.7-4.8-1.4-8-4.9-8-9.7V6.2l8-3z"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinejoin="round"
    />
    <path
      d="M9.2 12.2 11.1 14l3.7-4.2"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

/**
 * Advice-only helper under a field. Never validates or blocks submit.
 *
 * @component
 * @param {Object} props
 * @param {string} props.id - FormattedMessage id
 * @param {string} [props.className]
 * @param {string} [props.rootClassName]
 * @param {'shield'|'lock'} [props.icon]
 * @returns {JSX.Element}
 */
const PrivacyTip = props => {
  const { id, className, rootClassName, icon = 'shield' } = props;
  const classes = classNames(rootClassName || css.root, className);

  return (
    <p className={classes} data-privacy-tip={id} role="note">
      {icon === 'lock' ? <LockIcon /> : <ShieldIcon />}
      <span>
        <FormattedMessage id={id} />
      </span>
    </p>
  );
};

export default PrivacyTip;
